<template>
  <div>
    <!-- Page Header Section Start Here -->
    <section class="page-header">
      <div class="container">
        <div class="page-title">
          <h2>Covid-19 How to Wash Your Hand</h2>
          <ul class="breadcrumb lab-ul">
            <li><router-link to="/">Home</router-link></li>
            <li>How to Wash Your Hand</li>
          </ul>
        </div>
      </div>
    </section>
    <!-- Page Header Section Ending Here -->
    <!-- safe actions section start here -->
    <section class="safe-actions style-2 padding-tb bg-action">
      <div class="container">
        <div
          class="section-header wow fadeInUp"
          data-wow-delay="0.3s"
          style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;"
        >
          <h2>How to Wash Your Hands</h2>
          <p>
            Dynamically formulate fully tested catalysts for change via focused
            methods of empowerment Assertively extend alternative synergy and
            extensive web services.
          </p>
        </div>
        <div
          class="row justify-content-center align-items-center"
          style=" counter-reset: topx;"
        >
          <div
            class="col-xl-3 col-lg-4 col-sm-6 col-12 wow fadeInUp"
            data-wow-delay="0.3s"
            style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;"
          >
            <div class="safe-item">
              <div class="safe-thumb">
                <img src="../assets/images/safe/01.jpg" alt="safe" />
              </div>
              <div class="safe-content">
                <h6>Wet Hands</h6>
              </div>
            </div>
          </div>
          <div
            class="col-xl-3 col-lg-4 col-sm-6 col-12 wow fadeInUp"
            data-wow-delay="0.3s"
            style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;"
          >
            <div class="safe-item">
              <div class="safe-thumb">
                <img src="../assets/images/safe//02.jpg" alt="safe" />
              </div>
              <div class="safe-content">
                <h6>Apply Soap</h6>
              </div>
            </div>
          </div>
          <div
            class="col-xl-3 col-lg-4 col-sm-6 col-12 wow fadeInUp"
            data-wow-delay="0.3s"
            style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;"
          >
            <div class="safe-item">
              <div class="safe-thumb">
                <img src="../assets/images/safe/03.jpg" alt="safe" />
              </div>
              <div class="safe-content">
                <h6>Rub Hands Palm to palm</h6>
              </div>
            </div>
          </div>
          <div
            class="col-xl-3 col-lg-4 col-sm-6 col-12 wow fadeInUp"
            data-wow-delay="0.3s"
            style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;"
          >
            <div class="safe-item">
              <div class="safe-thumb">
                <img src="../assets/images/safe/04.jpg" alt="safe" />
              </div>
              <div class="safe-content">
                <h6>Lather The Back of Both Hands</h6>
              </div>
            </div>
          </div>
          <div
            class="col-xl-3 col-lg-4 col-sm-6 col-12 wow fadeInUp"
            data-wow-delay="0.3s"
            style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;"
          >
            <div class="safe-item">
              <div class="safe-thumb">
                <img src="../assets/images/safe/05.jpg" alt="safe" />
              </div>
              <div class="safe-content">
                <h6>Scrub Between Your Fingers</h6>
              </div>
            </div>
          </div>
          <div
            class="col-xl-3 col-lg-4 col-sm-6 col-12 wow fadeInUp"
            data-wow-delay="0.3s"
            style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;"
          >
            <div class="safe-item">
              <div class="safe-thumb">
                <img src="../assets/images/safe/06.jpg" alt="safe" />
              </div>
              <div class="safe-content">
                <h6>Rub The Back of Fingers on The Opposing Palm</h6>
              </div>
            </div>
          </div>
          <div
            class="col-xl-3 col-lg-4 col-sm-6 col-12 wow fadeInUp"
            data-wow-delay="0.3s"
            style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;"
          >
            <div class="safe-item">
              <div class="safe-thumb">
                <img src="../assets/images/safe/07.jpg" alt="safe" />
              </div>
              <div class="safe-content">
                <h6>Clean Thumbs</h6>
              </div>
            </div>
          </div>
          <div
            class="col-xl-3 col-lg-4 col-sm-6 col-12 wow fadeInUp"
            data-wow-delay="0.3s"
            style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;"
          >
            <div class="safe-item">
              <div class="safe-thumb">
                <img src="../assets/images/safe/08.jpg" alt="safe" />
              </div>
              <div class="safe-content">
                <h6>Wash Fingernails And Fingertips</h6>
              </div>
            </div>
          </div>
          <div
            class="col-xl-3 col-lg-4 col-sm-6 col-12 wow fadeInUp"
            data-wow-delay="0.3s"
            style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;"
          >
            <div class="safe-item">
              <div class="safe-thumb">
                <img src="../assets/images/safe/09.jpg" alt="safe" />
              </div>
              <div class="safe-content">
                <h6>Rinse Hands</h6>
              </div>
            </div>
          </div>
          <div
            class="col-xl-3 col-lg-4 col-sm-6 col-12 wow fadeInUp"
            data-wow-delay="0.3s"
            style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;"
          >
            <div class="safe-item">
              <div class="safe-thumb">
                <img src="../assets/images/safe/10.jpg" alt="safe" />
              </div>
              <div class="safe-content">
                <h6>Dry with a Single Use Towel</h6>
              </div>
            </div>
          </div>
          <div
            class="col-xl-3 col-lg-4 col-sm-6 col-12 wow fadeInUp"
            data-wow-delay="0.3s"
            style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;"
          >
            <div class="safe-item">
              <div class="safe-thumb">
                <img src="../assets/images/safe/11.jpg" alt="safe" />
              </div>
              <div class="safe-content">
                <h6>Use The Towel to Rurn off The Foucet</h6>
              </div>
            </div>
          </div>
          <div
            class="col-xl-3 col-lg-4 col-sm-6 col-12 wow fadeInUp"
            data-wow-delay="0.3s"
            style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;"
          >
            <div class="safe-item">
              <div class="safe-thumb">
                <img src="../assets/images/safe/12.jpg" alt="safe" />
              </div>
              <div class="safe-content">
                <h6>Your Hands Are Clean</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- safe actions section ends here -->
  </div>
</template>
<script>
export default {
  name: "WashHands",
  components: {

  }
};
</script>
